import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetRolePermissionsAction} from '../action';

const tableId = 'rolePermissions';

function* execute({payload: {roleId, tableDataRequest}}: GetRolePermissionsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getPermissionsAssignedToRole,
        successAction: adminAction.getRolePermissionsSuccess,
        tableId,
        pathParams: {
            roleId,
        },
    }));
}

/** Runs the admin saga that loads permissions assigned to the selected role. */
export function* getRolePermissionsV2Saga(): SagaIterator {
    yield takeLatestF('admin/GET_ROLE_PERMISSIONS', execute);
}
